// @flow
import React from 'react';
import type { BrandSequence } from 'store/modules/brands';
import { fromNow } from 'lib/common';
import { Link } from 'react-router-dom';
import FakeLink from 'components/common/FakeLink';
import cx from 'classnames';
import './BrandSequences.scss';

type BrandSequenceItemProps = {
  sequence: BrandSequence,
  username: string,
  active: boolean,
};

type Props = {
  sequences: ?(BrandSequence[]),
  username: string,
  currentBrandId: string,
};

const BrandSequenceItem = ({ sequence, username, active }: BrandSequenceItemProps) => {
  const { title, body, meta, url_slug, created_at } = sequence;
  const to = `/@${username}/brands/${url_slug}`;
  return (
    <FakeLink className={cx('BrandSequenceItem', { active })} to={to}>
      <div className="date">{fromNow(created_at)}</div>
      <div className="title">
        <Link to={to}>{title}</Link>
      </div>
      <p>{(meta && meta.short_description) || body}</p>
    </FakeLink>
  );
};

const BrandSequences = ({ sequences, username, currentBrandId }: Props) => {
  if (!sequences || sequences.length === 0 || sequences.length === 1) return null;
  return (
    <div className="BrandSequences">
      <div className="wrapper">
        <h3 className="title">다른 파트너 둘러보기</h3>
        {sequences.map(s => (
          <BrandSequenceItem
            key={s.id}
            sequence={s}
            username={username}
            active={s.id === currentBrandId}
          />
        ))}
      </div>
    </div>
  );
};

export default BrandSequences;



// WEBPACK FOOTER //
// ./src/components/brand/BrandSequences/BrandSequences.js